import React, { useEffect, } from "react";
import { Link, useParams } from "react-router-dom";
import Footer from "../../footer";
import {
  User1,
  Html,
  Pdf
} from "../../imagepath";
import { Col, Row } from "react-bootstrap";
import CourseHeader from "../../header/index";

import StudentSideBar from "../../student/sidebar";
import Bannerpage from "../../Banner";
import { useDispatch, useSelector } from "react-redux";
import { ArticlegetById } from "../../../Redux/Articles/articleSlice";
import moment from "moment";

// import queryString from "query-string";

export default function InstructorReviews() {

  const { article } = useSelector((state) => state.articleData)
  console.log(article, "artl")
 

  const dispatch = useDispatch();
  const { slug } = useParams();

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    dispatch(ArticlegetById(slug));
  }, [])

 

  return (
    <>
      <CourseHeader activeMenu={"CourseDetails"} />

      <Bannerpage name={slug} />

      <div className="container-fluid p-2">
        <Row>
          <StudentSideBar />
          <Col lg={8} md={8} sm={12} xs={12}>
            <div>
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="settings-widget">
                      <div className="settings-inner-blk p-0">
                        <div className="comman-space">
                          <h3>Articles in press and Articles in process</h3>
                        </div>
                        {article?.data?.map((item, index) => {
                          return <div key={index} style={{ padding: 10 }}>
                            <Row >
                              <Col>
                                {String(item?.article_types?.[0]?.name).charAt(0).toUpperCase() + String(item?.article_types?.[0]?.name).slice(1)}
                              </Col>
                              <Col>
                                <div style={{ textAlign: 'right' }}>
                                  Pages: {item?.start_page_number} - {item?.end_page_number}
                                </div>
                              </Col>
                            </Row>
                            <div className="sell-course-head">
                            </div>
                            <div className="comman-space" >
                              <div className="instruct-review-blk ">
                                <div className="review-item">
                                  <div className="instructor-wrap border-0 m-0">
                                    <div className="about-instructor">
                                      <div className="abt-instructor-img">
                                        <Link
                                          onClick={scrollToTop}
                                        >
                                          <img
                                            src={User1}
                                            alt="img"
                                            className="img-fluid"
                                          />
                                        </Link>
                                      </div>
                                      <div className="instructor-detail">
                                        <h5>
                                          <Link
                                            to={`/${slug}/article/${item?.slug}`}
                                            onClick={scrollToTop}
                                          // target="_blank"
                                          >
                                            {String(item?.article_title).charAt(0).toUpperCase() + String(item?.article_title).slice(1)}
                                          </Link>
                                        </h5>
                                        <p>
                                          <Link
                                            to={`/ ${slug} /author/${item?.slug}/article`}
                                            state={"article"}
                                            onClick={scrollToTop}
                                          // target="_blank"
                                          >
                                            {/* <em>{item?.authors?.[0]?.author_name}</em> */}
                                            {item?.authors?.map((items, indexData) => {
                                              return <em key={indexData} >{items?.author_name}{indexData < item?.authors?.length - 1 && ', '}</em>
                                            })}
                                          </Link>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="rating">
                                      <i className="fa-brands fa-facebook"></i>
                                      <i className="fa-brands fa-twitter"></i>
                                      <i className="fa-brands fa-linkedin"></i>
                                      <i className="fa-brands fa-instagram"></i>
                                    </div>
                                  </div>
                                  <p className="rev-info">
                                    Published Date: {moment(item?.published_date).format("YYYY-MM-DD")}; Received Date: {moment(item?.received_date).format("YYYY-MM-DD")}
                                    {/* <div dangerouslySetInnerHTML={{ __html: item?.abstract }}></div> */}
                                  </p>
                                  <div className="about-instructor">
                                    <div>
                                      {item?.article_access_types === 'open access' ? (
                                        <Link
                                          to={`/${slug}/article/${item?.slug}`}
                                          state={"article"}
                                          onClick={scrollToTop}
                                        // target="_blank"
                                        >
                                          <img src={Html} alt="html" width="30" />
                                        </Link>
                                      ) : (
                                        <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                          <img src={Html} alt="html" width="30" />
                                        </span>
                                      )}
                                    </div>
                                    <div >
                                      {item?.article_access_types === 'open access' ? (
                                        <Link
                                          to={item?.pdf_url}
                                          target="_blank"
                                          onClick={scrollToTop}
                                        >
                                          <img
                                            src={Pdf}
                                            alt="img"
                                            className="img-fluid"
                                          />
                                        </Link>
                                      ) : (
                                        <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                          <img src={Pdf} alt="pdf" />
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div >
      <Footer />
    </>
  );
}
